module.exports = __webpack_public_path__ + "static/media/photo_profile_1.157d036b.webp";